import React from "react";
import styles from "./styles.css";
import Modal from "../../shared/modal";
import { PropTypes } from "prop-types";
// import DistanceStepper from "../distance-stepper/component";
// import USPCard from "../usp-card/component";
import Button from "../../shared/button";
import { getCmsPageSection } from "../../../utils/helpers/get-cms-page-section";
// import { GA_EVENTS } from "../car-details/tracking";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import DistanceStepper from "../distance-stepper/component";
import USPCard from "../usp-card/component";
const InterStateCarModal = ({
    handleModalClose = () => {},
    isOpen,
    cmsConfig
    // stateData
}) => {
    const {data: {
        pageSections = []
    } = {} } = cmsConfig || {};

    const interStateCarModalData = getCmsPageSection("INTERSTATE_CONTENT", pageSections) || {};
    const {
        meta: {
            data: {
                modalContent
            } = {}
        } = {},
        ctaText
    } = interStateCarModalData?.pageSection || {};

    const {
        headerImage,
        pathwayTracker,
        modalHeaderText,
        valueProps = []
    } = modalContent || {};

    const closeModal = async () => {
        handleModalClose(false);
        await yieldToMain();
    };
    return (
        <Modal isOpen={isOpen} close={() => closeModal(true)}>
            <div styleName={"styles.modalWrapper"}>
                <div styleName={"styles.headerWrap"}>
                    <img src={headerImage} alt="header image"/>
                    <div styleName="styles.gradient" />
                    <p styleName="styles.headerText" >
                        {modalHeaderText || ""}
                    </p>
                </div>
                <div styleName="styles.contentWrapper">
                    <DistanceStepper pathwayTracker={pathwayTracker} />
                    {(valueProps || []).map((item, index) => (
                        <USPCard
                            id={index}
                            image={item.icon}
                            title={item.text || ""}
                        />
                    ))}
                    <div styleName="styles.buttonWrapper">
                        {ctaText && <Button text={ctaText} onClick={() => closeModal(false)}/>}
                    </div>
                </div>

            </div>
        </Modal>
    );
};

InterStateCarModal.propTypes = {
    handleModalClose: PropTypes.func,
    isOpen: PropTypes.bool,
    cmsConfig: PropTypes.object,
    stateData: PropTypes.object
};
export default InterStateCarModal;
